import React from "react";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@heroui/react";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

interface PlaygroundDeleteConfirmationProps {
  isOpen: boolean;
  nodeId: string;
  nodeType: string;
  connectionCount: number;
  onCancel: () => void;
  onConfirm: () => void;
}

const PlaygroundDeleteConfirmation: React.FC<PlaygroundDeleteConfirmationProps> = ({
  isOpen,
  nodeId,
  nodeType,
  connectionCount,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation();

  const nodeLabel = nodeType === "agent" ? t("agent") : nodeType === "team" ? t("team") : t("node");

  return (
    <Modal isOpen={isOpen} size="sm" onClose={onCancel}>
      <ModalContent>
        <ModalHeader className="flex items-center gap-2">
          <Icon className="w-5 h-5 text-danger" icon="solar:trash-bin-trash-linear" />
          {t("Delete")} {nodeLabel}
        </ModalHeader>
        <ModalBody>
          <p className="text-sm text-default-600">
            {t("Are you sure you want to delete")} <strong>{nodeId}</strong>?
          </p>
          {connectionCount > 0 && (
            <div className="p-3 rounded-lg bg-warning-50 dark:bg-warning-900/20 mt-2">
              <p className="text-xs text-warning-700 dark:text-warning-300">
                {t("This node has {{count}} connection(s) that will also be removed.", {
                  count: connectionCount,
                })}
              </p>
            </div>
          )}
          {nodeType === "team" && (
            <div className="p-3 rounded-lg bg-default-100 mt-2">
              <p className="text-xs text-default-500">
                {t("Team members will remain in the workflow as standalone agents.")}
              </p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button size="sm" variant="flat" onPress={onCancel}>
            {t("Cancel")}
          </Button>
          <Button color="danger" size="sm" onPress={onConfirm}>
            {t("Delete")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default PlaygroundDeleteConfirmation;
